import { useContext } from 'react';
import { PublicApiClientContextProps, PublicApiClientContext } from '../context/PublicApiClientProvider';

export const usePublicApiClient = (): PublicApiClientContextProps => {
  const value = useContext(PublicApiClientContext);
  if (value === undefined) {
    throw new Error('usePublicApiClient must be used within a PublicApiClientProvider');
  }

  return value;
};
